export const VEHICLE_WEIGHT_KG = 3000;
export const VAT_RATE = 1.2;
export const MARGIN_RATE = 1.25;

export const CREDIT_TYPE = 'credit';
export const COUPON_TYPE = 'coupon';
export const DISCOUNT_TYPE = 'discount';
export const TRANSPORTATION_FEE_TYPE = 'fee';
export const TRANSPORTATION_FEE_SKU = 'fixter-transportation-fee';
export const TRANSPORTATIION_FEE_TITLE = 'Fixter C&D fee';
export const ADJUSTMENT_TYPE = 'adjustment';
export const ADJUSTMENT_TITLE = 'Adjustment';
export const COLLECTION_AND_DELIVERY_TYPE = 'c&d';
export const DRIVER_FEE = 'driver-fee';
export const ADDITIONAL_DISCOUNT_TYPE = 'additional-discount';

export const COMPLETE_LIMIT = 14;

// account code purchases
export const ACP_205 = 205;
export const ACP_307 = 307;
export const ACP_308 = 308;

export const LINE_ITEMS_TABLE_DATA = Object.freeze([
  // not passed to save
  'subLineItems',
  // not displayed data
  'operationId',
  'quoteId',
  'title',
  'source',
  'parentId',
  'discount',
  'serviceType',
  'accountCode',
  'accountCodePurchases',
  'type',
  'vatExempt',
  'order',
  'fixedCost',
  // displayed data
  'workSummary',
  'labourTime',
  'labourCost',
  'partsQuantity',
  'partsPrice',
  'quantity',
  'garageCost',
  'garageCostWithVat',
  'fixedCostWithVAT',
  'status',
  'createdAt',
  'urgency',
  'metadata',
  'sku',
  'workStatus',
  'comments',
  'category',
  'searchTerms',
  'brandName',
  'partReferenceNumber',
]);

export const LINE_ITEMS_PRICE_COLUMNS = Object.freeze([
  'garageCost',
  'garageCostWithVat',
  'fixedCost',
  'fixedCostWithVAT',
  'partsPrice',
  'labourCost',
]);

export const QUOTE_PRICE_COLUMNS = Object.freeze([
  'customerTotalPriceWithVAT',
  'customerTotalPriceWithoutVAT',
  'customerTotalMarketingPrice',
  'garageTotalPriceWithoutVAT',
  'garageGoodsTotalWithVAT',
  'customerFinalVAT',
  'garageGoodsTotalBeforeVAT',
  'customerGoodsTotalWithVAT',
  'garageTotalPriceWithVAT',
  'garageFinalVAT',
  'customerGoodsTotalBeforeVAT',
  'customerDiscount',
]);

export const OPEN_POPUP = '@maia/WorkDetails/OPEN_POPUP';
export const CLOSE_POPUP = '@maia/WorkDetails/CLOSE_POPUP';
export const INFOCARD_LOADED = '@maia/WorkDetails/INFOCARD_LOADED';
export const ADD_DRAFT_WO = '@maia/WorkDetails/ADD_DRAFT_WO';
export const EDIT_LINE_ITEM = '@maia/WorkDetails/EDIT_LINE_ITEM';
export const SAVE_WORK_OPERATION = '@maia/WorkDetails/SAVE_WORK_OPERATION';
export const DELETE_WORK_OPERATION = '@maia/WorkDetails/DELETE_WORK_OPERATION';
/**
 * @deprecated
 */
export const DELETE_LINE_ITEM = '@maia/WorkDetails/DELETE_LINE_ITEM';
export const SAVE_QUOTE = '@maia/WorkDetails/SAVE_QUOTE';
export const LOAD_QUOTE_SUCCESS = '@maia/WorkDetails/LOAD_QUOTE_SUCCESS';
export const VALIDATE_CAMPAIGN_ACTION = '@maia/WorkDetails/VALIDATE_CAMPAIGN_ACTION';
export const ADD_CAMPAIGN_CODE = '@maia/WorkDetails/ADD_CAMPAIGN_CODE';
export const GET_CAMPAIGN_CODE_SUCCESS = '@maia/WorkDetails/GET_CAMPAIGN_CODE_SUCCESS';
export const GET_CAMPAIGN_CODE_ERROR = '@maia/WorkDetails/GET_CAMPAIGN_CODE_ERROR';
export const WORK_DETAILS_ERROR = '@maia/WorkDetails/WORK_DETAILS_ERROR';
export const SEND_JOB_INVITE = '@maia/WorkDetails/SEND_JOB_INVITE';
export const SEND_QUOTE_TO_CUSTOMER = '@maia/WorkDetails/SEND_QUOTE_TO_CUSTOMER';
export const UPDATE_TO_CUSTOMER_REVIEW = '@maia/WorkDetails/UPDATE_TO_CUSTOMER_REVIEW';
export const SAVING_ROW = '@maia/WorkDetails/SAVING_ROW';
export const EDIT_ROW = '@maia/WorkDetails/EDIT_ROW';
export const GARAGE_WORK_OPERATION_PRICES = '@maia/WorkDetails/GARAGE_WORK_OPERATION_PRICES';
export const GARAGE_WORK_OPERATION_PRICES_SUCCESS = '@maia/WorkDetails/GARAGE_WORK_OPERATION_PRICES_SUCCESS';
export const GARAGE_WORK_OPERATION_PRICES_ERROR = '@maia/WorkDetails/GARAGE_WORK_OPERATION_PRICES_ERROR';
export const ORIGINAL_WORK_OPERATION_PRICES = '@maia/WorkDetails/ORIGINAL_WORK_OPERATION_PRICES';
export const ORIGINAL_WORK_OPERATION_PRICES_SUCCESS =
  '@maia/WorkDetails/ORIGINAL_WORK_OPERATION_PRICES_SUCCESS';
export const ORIGINAL_WORK_OPERATION_PRICES_ERROR = '@maia/WorkDetails/ORIGINAL_WORK_OPERATION_PRICES_ERROR';
export const APPROVE_PROPOSED_WORK_OPERATION = '@maia/WorkDetails/APPROVE_PROPOSED_WORK_OPERATION';
export const DECLINE_PROPOSED_WORK_OPERATION = '@maia/WorkDetails/DECLINE_PROPOSED_WORK_OPERATION';
export const FINALISE_PROPOSED_WORK_OPERATION = '@maia/WorkDetails/FINALISE_PROPOSED_WORK_OPERATION';
export const FINALISE_PROPOSED_WORK_OPERATION_SUCCESS =
  '@maia/WorkDetails/FINALISE_PROPOSED_WORK_OPERATION_SUCCESS';
export const FINALISE_PROPOSED_WORK_OPERATION_ERROR =
  '@maia/WorkDetails/FINALISE_PROPOSED_WORK_OPERATION_ERROR';
